import { Controller } from "@hotwired/stimulus";

// Este controlador é usado para preservar o parâmetro date_range na URL após o envio do formulário
export default class extends Controller {
  static values = {
    param: String,
  };

  connect() {
    // Adicionar o manipulador de sucesso ao turbo:submit-end
    document.addEventListener(
      "turbo:submit-end",
      this.preserveFilterParams.bind(this)
    );
  }

  disconnect() {
    document.removeEventListener(
      "turbo:submit-end",
      this.preserveFilterParams.bind(this)
    );
  }

  preserveFilterParams(event) {
    // Verifica se a submissão foi bem-sucedida
    if (event.detail.success) {
      // Obtém a URL atual
      const url = new URL(window.location.href);
      const searchParams = new URLSearchParams(url.search);
      const currentDateRange = searchParams.get("date_range");

      // Se há um parâmetro date_range na URL atual
      if (currentDateRange) {
        setTimeout(() => {
          // Usa setTimeout para garantir que o Turbo tenha terminado de processar a resposta
          const newUrl = new URL(window.location.href);
          // Se a nova URL não tem o parâmetro, adiciona-o
          if (!newUrl.searchParams.has("date_range")) {
            newUrl.searchParams.set("date_range", currentDateRange);
            history.replaceState({}, "", newUrl.toString());
          }
        }, 100);
      }
    }
  }
}
